// electron 下 window.location.protocol 不是 http， window.location.host 为 "."
console.log("window.location.host:", window.location.host)
console.log("window.location.protocol:", window.location.protocol)
let baseUrl = `${window.location.protocol === "https:" ? "wss" : "ws" }://${window.location.host === "." ? "localhost:22222" : window.location.host}/ws`

export default {
    baseUrl,
}
